import { useEffect } from 'react'
import { FilterCategory } from '~/@types/models'
import { EFilterName } from '~/components/filter'
import { ISelectedFilters, TFilter, useFilterContext } from '~/context/filters'
interface IProps {
  dataFilters?: FilterCategory[]
  collectionHandle: string
}

export const useUrlFilters = ({ dataFilters, collectionHandle }: IProps) => {
  const { setSelectedFilters, setCurrentFilters } = useFilterContext()

  useEffect(() => {
    function getFilterFromStorage() {
      const bsolFilters = localStorage.getItem(EFilterName.filter)

      if (!bsolFilters) {
        // eslint-disable-next-line no-console
        console.log('NO FILTERS FOUND')
        return
      }

      const filters = JSON.parse(bsolFilters)
      const _filters = Object.keys(filters.filters)
        .map(key => {
          return `${key}=${filters.filters[key]
            .map((filter: any) => filter.value.replaceAll(' ', '+'))
            .join(';')}`
        })
        .join('&')

      // eslint-disable-next-line no-console
      console.log(`${location.pathname}?${_filters}`)
    }

    if (typeof window !== 'undefined') {
      window.getFilterFromStorage = getFilterFromStorage
    }
  }, [])

  useEffect(() => {
    if (!dataFilters) return

    const localFilters = localStorage.getItem(EFilterName.filter)
    const searchParams = new URLSearchParams(window.location.search)

    if (searchParams.size) {
      const bsolFilters = {
        type: collectionHandle,
        filters: {},
      }

      for (const [key, value] of searchParams.entries()) {
        const _filters: string[] = value.split(';')
        const filters: TFilter[] = []
        const isFilter = dataFilters?.find(filter => filter.name === key)

        if (!isFilter) {
          return
        }

        if (_filters.length > 1) {
          _filters.forEach(_filter => {
            filters.push({
              name: _filter === 'true' ? 'Yes' : _filter,
              value: _filter === 'true' ? true : _filter,
            })
          })
        } else {
          filters.push({
            name: _filters[0] === 'true' ? 'Yes' : _filters[0],
            value: _filters[0] === 'true' ? true : _filters[0],
          })
        }

        bsolFilters.filters = {
          ...bsolFilters.filters,
          [key]: filters,
        }
      }

      localStorage.setItem('bsolFilters', JSON.stringify(bsolFilters))
    }

    if (localFilters) {
      const parsedLocalFilters = JSON.parse(localFilters)
      if (parsedLocalFilters.type !== collectionHandle) {
        localStorage.removeItem(EFilterName.filter)
        return
      }
      setSelectedFilters(parsedLocalFilters.filters)
      setCurrentFilters(state => ({
        ...state,
        selectedFilters: parsedLocalFilters.filters,
        type: collectionHandle,
      }))
    }
  }, [])

  const updateFilters = (filters: ISelectedFilters) => {
    const localFilters = localStorage.getItem(EFilterName.filter) || '{}'
    const uniqueParams = new URLSearchParams()
    const pathname = window.location.pathname

    Object.entries(filters).forEach(([key, value]) => {
      const values = value
        .map(filter => {
          return filter.value
        })
        .join(';')

      uniqueParams.append(key, values)
    })

    const newUrl = `${pathname}?${uniqueParams.toString()}`
    window.history.replaceState({ path: newUrl }, '', newUrl)

    const collectionFilters = {
      ...JSON.parse(localFilters),
      type: collectionHandle,
      filters: filters,
    }
    localStorage.setItem(EFilterName.filter, JSON.stringify(collectionFilters))
  }

  const clearUrlFilters = () => {
    const searchParams = new URLSearchParams(window.location.search)
    const pathname = window.location.pathname

    searchParams.forEach((value, key) => {
      searchParams.delete(key)
    })
    const newUrl = `${pathname}`
    window.history.replaceState({ path: newUrl }, '', newUrl)
  }

  return { updateFilters, clearUrlFilters }
}
